import axios from 'axios';


export default {
    namespaced: true,
    state: {
        playerHipaaConsentForm: {},
        loadingPlayerHipaaConsentForm: false,
        loadingPlayerHipaaConsentFormError: null,
    },
    getters: {
        playerHipaaConsentForm: (state) => state.playerHipaaConsentForm,
        loadingPlayerHipaaConsentForm: (state) => state.loadingPlayerHipaaConsentForm,
        loadingPlayerHipaaConsentFormError: (state) => state.loadingPlayerHipaaConsentFormError,
        hasTheHipaaConsentFormBeenSigned: (state) => {
            return state.playerHipaaConsentForm && state.playerHipaaConsentForm.signatureDateForm;
        },
    },
    mutations: {
        setPlayerHipaaConsentForm(state, data) {
            state.playerHipaaConsentForm = data;
        },
        startLoadingPlayerHipaaConsentForm(state) {
            state.loadingPlayerHipaaConsentForm = true;
        },
        stopLoadingPlayerHipaaConsentForm(state) {
            state.loadingPlayerHipaaConsentForm = false;
        },
        setLoadingPlayerHipaaConsentFormError(state, error) {
            state.loadingPlayerHipaaConsentFormError = error;
        },
        clearLoadingPlayerHipaaConsentFormError(state) {
            state.loadingPlayerHipaaConsentFormError = null;
        },
    },
    actions: {
        async getPlayerHipaaConsentForm({ commit }, { playerIdentifier, playerEmail }) {
            commit('startLoadingPlayerHipaaConsentForm');
            try {
                const result = await axios.get(`${process.env.VUE_APP_API_URL}/playerconsentform/${playerIdentifier}/${playerEmail}/hipaa-form`);
                const data = await result.data;
                commit('setPlayerHipaaConsentForm', data);
            } catch (error) {
                console.error('Error while retrieving the player hipaa consent form', error.response);
                commit('setLoadingPlayerHipaaConsentFormError', error.response.data.name);
            } finally {
                commit('stopLoadingPlayerHipaaConsentForm');
            }
        },
    },
}